import BaseListagem from "components/BaseListagem";
import Setor from "model/administracao/cadastro/Setor";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Button } from "primereact/button";
import { Column, ColumnFilterApplyTemplateOptions, ColumnFilterElementTemplateOptions } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect, MultiSelectChangeEvent } from "primereact/multiselect";
import { useEffect, useState } from "react";
import AcaoAuditoriaService from "service/auditoria5s/AcaoAuditoriaService";
import UsuarioLogadoService from "service/usuario/UsuarioLogadoService";
import { converterData } from "utils/convert";
import { dateFilterTemplate, DateMatchModeOptions, dateRangeFilterTemplate, IdMatchModeOptions, NumberMatchModeOptions, TextMatchModeOptions } from "utils/filterUtils";

const acaoAuditoriaService = new AcaoAuditoriaService();
const usuarioLogadoService = new UsuarioLogadoService();

export default function AcaoAuditoriaListagem() {

    const [setoresDisponiveis, setSetoresDisponiveis] = useState<Setor[]>([]);

    const [usuarios, setUsuarios] = useState<any[]>([]);

    const defaultFilters: DataTableFilterMeta = {
        numero: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        setor: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        nome: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        createdAt: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        dataLimite: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        responsavel: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        status: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.IN,
                }
            ],
            operator: FilterOperator.AND
        }
    }

    const usuarioFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <Dropdown value={options.value} options={usuarios} filter
            onChange={(e) => options.filterCallback(e.value)}
            optionLabel="nome" optionValue="id" placeholder="Qualquer" className="p-column-filter" />
    }

    const setorFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <Dropdown value={options.value} options={setoresDisponiveis} filter
            onChange={(e) => options.filterCallback(e.value)}
            optionLabel="nome" optionValue="id" placeholder="Qualquer" className="p-column-filter" />
    }

    useEffect(() => {
        acaoAuditoriaService.getSetoresDisponiveis().then(response => setSetoresDisponiveis(response)).catch(() => setSetoresDisponiveis([]));
    
        acaoAuditoriaService.getUsuarios().then(response => setUsuarios(response)).catch(() => setUsuarios([]));
    }, []);

    const matchModeOptions = [
        { label: 'Está em', value: FilterMatchMode.IN },
        { label: 'Não está em', value: FilterMatchMode.NOT_EQUALS }
    ]

    const filterApplyTemplate = (options: ColumnFilterApplyTemplateOptions) => {
        return <Button type="button" label="Aplicar" onClick={options.filterApplyCallback} ></Button>;
    };

    const representativeFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <MultiSelect value={options.value} options={acaoAuditoriaService.getStatusFilter()}
            onChange={(e: MultiSelectChangeEvent) => options.filterCallback(e.value)}
            optionLabel="label" optionValue="value" placeholder="Qualquer" className="p-column-filter"
        />;
    };

    return (
        <>
            <BaseListagem ordenacao="itemAuditoria.classeAuditoria.auditoria.numero,DESC" service={acaoAuditoriaService} urlService="/acaoAuditoria" tituloPagina={'Ações de Auditoria'}
                showNewButton={false}
                showRemoveButton={false}
                defaultFilters={defaultFilters} showClearFilterButton
                nome="acoesauditoria"
            >
                <Column
                    field="itemAuditoria.classeAuditoria.auditoria.numero" header="Nr. Auditoria" filterField="numero"
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={NumberMatchModeOptions} filterApply={filterApplyTemplate}
                />
                <Column
                    field="itemAuditoria.classeAuditoria.auditoria.setor.nome" header="Setor" filterField="setor"
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={setorFilterTemplate}
                />
                <Column
                    field="nome" header="Nome"
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate}
                />
                <Column field="createdAt" header="Criado em" body={(rowData) => converterData(rowData.createdAt)}
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={DateMatchModeOptions} filterApply={filterApplyTemplate}
                    filterElement={dateRangeFilterTemplate} showFilterMenuOptions={false} filterMenuStyle={{ zIndex: 50 }} />
                <Column field="dataLimite" header="Dt. Limite" body={(rowData) => converterData(rowData.dataLimite)}
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={DateMatchModeOptions} filterApply={filterApplyTemplate}
                    filterElement={dateFilterTemplate} filterMenuStyle={{ zIndex: 50 }} />
                <Column
                    field="responsavel.nome" header="Responsável" filterField="responsavel"
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={usuarioFilterTemplate}
                />
                <Column field="status" header="Status" filterField="status"
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={matchModeOptions} filterApply={filterApplyTemplate} filterElement={representativeFilterTemplate}
                    body={(rowData) => acaoAuditoriaService.getStatus(rowData.status)}
                />
            </BaseListagem>
        </>

    )
}
